export default __webpack_public_path__ + "static/media/404.b7e21387.svg";